import { validateStepsByValidationResults } from 'sos-eservice-common/js/Redux/Reducers/validation.helpers';
import { OmbudOrderProps } from './Ombud.types';
import { OmbudFormGlobals } from './models/OmbudFormGlobals';

export function getInitialState(props: OmbudOrderProps) {
  const {
    model,
    orderId,
    translations,
    files,
    validationResults,
    homePageUrl,
    firstName,
    lastName,
    thankYouPageUrl,
    stepOneEditableTexts,
    powerOfAttorneyLink,
    numberOfSentForToday,
    readMoreAboutAttachmentsLink,
    hitSummaryStep,
  } = props;

  const registers = {};
  const globals = {
    currentStep: 1,
    hasHitSummary: false,
    firstName,
    lastName,
    orderId,
    shouldShowDelete: !!orderId,
    thankYouPageUrl,
    translations,
    stepOneEditableTexts,
    homePageUrl,
    powerOfAttorneyLink,
    numberOfSentForToday,
    isSending: false,
    readMoreAboutAttachmentsLink,
    hitSummaryStep,
  } as Partial<OmbudFormGlobals>;

  const initialValidationState = {
    stepValidationMap: {
      0: {
        isValid: false,
        stepId: 0,
      },
      1: {
        isValid: false,
        stepId: 1,
      },
      2: {
        isValid: false,
        stepId: 2,
      },
    },
    validationResults,
    fullValidationResults: validationResults,
    touchedFields: [],
  };
  const validationState = validateStepsByValidationResults(initialValidationState);

  return {
    files,
    formModel: model,
    globals,
    registers,
    validationState,
  };
}
